import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initI18n } from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Render once translations are ready, so the first screen is already in the saved language
initI18n().finally(() => {
  root.render(
    // <React.StrictMode>
     <Provider store={store}>
          <App />
      </Provider>
    // </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
